import React from 'react';

import { Content } from './Content.js';
import Pipe from './../../Pipe/Pipe.jsx';
import BackgroundSquare from './BackgroundSquare.jsx';

export default class Extension extends React.Component {

  render() {
    return (
      <div className="col-xs-16 Extension">
        <Pipe scrollProgressType="pipe" />
        <div className="row">
          <div className="col-xs-16">
            <div className="big-text" data-scroll-item-once>{ Content[this.props.page].headline }</div>
          </div>
        </div>
        <Pipe scrollProgressType="pipe" />
        <div className="row squares">
          <div className="col-xs-16 col-sm-5 statement creativity">
            <div className="text-container" data-scroll-item-once>
              <h2>{ Content[this.props.page].statement1 }</h2>
            </div>
            <BackgroundSquare scrollProgressType="box" />
          </div>
          <div className="col-xs-16 col-sm-5 statement risk-taking">
            <div className="text-container" data-scroll-item-once>
              <h2>{ Content[this.props.page].statement2 }</h2>
            </div>
            <BackgroundSquare scrollProgressType="box" />
          </div>
          <div className="col-xs-16 col-sm-6 statement story-development">
            <div className="text-container" data-scroll-item-once>
              <h2>{ Content[this.props.page].statement3 }</h2>
            </div>
            <BackgroundSquare scrollProgressType="box" />
          </div>
        </div>
      </div>
    );
  }

};
